import {AppUrls} from 'shared/config/model/urls';

import React from 'react';
import cn from 'classnames';
import {Link} from 'react-router-dom';

import Logo from 'shared/ui/icons/General/Logo';
import LogoEn from 'shared/ui/icons/General/LogoEn';
import {isTranslate} from 'shared/lib/lang';

import MainMenu from '../../MainMenu/MainMenu';

import TariffBanner from './TariffBanner/TariffBanner';
import BrotherhoodBanner from './BrotherhoodBanner/BrotherhoodBanner';

import styles from './Navigation.module.scss';

interface INavigationProps {
    opened: boolean
}

const Navigation: React.FC<INavigationProps> = ({opened}) => {

    return (
        <nav
            className={cn(
                styles.nav,
                {[styles.opened]: opened},
                styles[isTranslate() ? 'enBackground' : 'ruBackground'],
            )}
            role="navigation"
        >
            <div className={cn([styles.sidebar, 'sidebar-collapse'])}>
                <div className={styles.top_nav}>
                    {
                        !isTranslate() ?
                            <Link to={AppUrls.HOME}>
                                <div className="logo-wrapper">
                                    <Logo />
                                </div>
                            </Link>
                            : <div className="logo-wrapper">
                                <LogoEn />
                            </div>
                    }
                    <MainMenu/>
                </div>
                <div className={styles.bottom_nav}>
                    {
                        !isTranslate() && <BrotherhoodBanner />
                    }
                    <TariffBanner />
                </div>
            </div>
        </nav>
    );
};

export default Navigation;